import { render, staticRenderFns } from "./PartCost.vue?vue&type=template&id=229d3ea4&"
import script from "./PartCost.vue?vue&type=script&lang=js&"
export * from "./PartCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports